import { createRouter, createWebHistory } from 'vue-router'

const routes = [
    {
        path: '/:gkid?',
        name: 'cawi',
        component: () => import(/* webpackChunkName: "cawi" */ '../views/Cawi.vue'),
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
})

export default router
